/** Asignar valor a model */
export function setModel(state, model) {
  state.model = model;
}

/** Asignar valor a baseDocuments */
export function setBaseDocuments(state, baseDocuments) {
  if (state.model.select_validate_wms) {
    baseDocuments.map(d => {
      d.disable_select = !d.wms_reception_dispatch
    })
  }

  if (state.selected_rows.length) {
    baseDocuments.map(d => {
      if (state.selected_rows.find(el => el.id == d.id)) {
        d.select_base_document = true
        d.selected_base_document = true
      }
    })
  }

  state.baseDocuments = baseDocuments;
}

export function resetBaseDocuments(state) {
  state.baseDocuments = [];
}

export function setUnds(state, unds) {

  state.baseDocuments.map(doc => {
    let und = unds.find(el => el.document_id == doc.id)
    if (und) {
    // setTimeout(() => {
      doc.total_backorder_quantity = und.total_backorder_quantity
      doc.total_unds = und.total_unds
      doc.loading_unds = false
    // }, 150);
    }
  })
}

/** Agrega un mensaje en caso de error*/
export function errorMessage(state, payload) {
  state.error = true;
  state.errorMessage = payload;
}

/** Asignar valor a branchoffices */
export function setBranchoffices(state, branchoffices) {
  state.branchoffices = branchoffices.map(p => {
    return { value: p.id, label: p.name };
  });
}

/** Asignar valor a warehouses */
export function setWarehouses(state, warehouses) {
  state.warehouses = warehouses.map(p => {
    return { value: p.id, label: p.warehouse_description };
  });
}

/** Asignar valor a status */
export function setStatus(state, status) {
  state.status = status.map(p => {
    return { value: p.id, label: p.name_parameter };
  });
}

/** Filtrar por búsqueda */
export function setFilterSearch(state, filter) {
  state.params.page = 1;
  state.params.filter = filter;
}
export function setLoadingBaseDocuments(state, data) {
  state.loadingBaseDocuments = data;
}

export function setDocumentsByAuthorize(state, data) {
  state.documentsByAuthorize = data;
}

export function setDateRangeParam(state) {
  // Seteamos la fecha
  var dt = new Date();

  // Fecha Actual
  let d = dt.toISOString().substring(0, 10);

  //Hace 30 Dias
  dt.setDate(dt.getDate() - 30);

  let d1 = dt.toISOString().substring(0, 10);

  state.params.filterDate = [
    d1,
    d,
  ];
}

export function setDateNullRangeParams (state) {
  state.params.filterDate = [
    '',
    '',
  ];
}

export function setLoadingAuthorizedDocuments(state, loadingAuthorizedDocuments){
  state.loadingAuthorizedDocuments = loadingAuthorizedDocuments;
}

export function setSelectedRows(state, selected_rows){
  state.selected_rows = selected_rows;
}

export function setProducts(state, products){
  state.products = products
}

export function setselected_documents(state, selected_document){
  state.selected_documents.push(selected_document)
}
export function deleteselected_documents(state, selected_document){
  let i = state.selected_documents.findIndex( element => element == selected_document);
  if (i >= 0) {
    state.selected_documents.splice(i, 1);
  }
}
export function setDisabledSelect(state, disabled_select){
  state.disabled_select = disabled_select;
}
export function setCities(state, cities){
  state.cities = cities
}
export function reSetselected_documents(state, selected_document){
  state.selected_documents = []
}
export function setUsers(state, users){
  state.users = users
}
export function setContacts(state, contacts){
  state.contacts = contacts
}
export function setDocumentsProducts(state, documents_products){
  state.documents_products = documents_products
  state.documents_products.map(dp => {
    let selected_dp = state.selected_documents_products.find(sdp => sdp.id == dp.id)
    let bo_quantity = state.model.back_order_control == 2 ? dp.backorder_quantity_2 : dp.backorder_quantity
    dp.quantity_doc = selected_dp ? selected_dp.quantity_doc : (documents_products.all_quantities ? (state.model.credit_note ? 1 : bo_quantity) : 0)
  })
}
export function addSelectedDocumentsProducts(state, documents_products){
  documents_products.map(new_dp => {
    let dp = state.selected_documents_products.find(sdp => sdp.id == new_dp.id)
    if (dp) {
      dp.quantity_doc       = new_dp.quantity_doc
      dp.total_value_brut   = new_dp.total_value_brut / new_dp.quantity * new_dp.quantity_doc
    }else{
      state.selected_documents_products.push({
        quantity_doc        : new_dp.quantity_doc,
        total_value_brut    : new_dp.total_value_brut,
        document_id         : new_dp.document_id,
        id                  : new_dp.id,
      })
    }
  })
}

export function deleteSelectedDocumentsProducts(state, document_id){
  state.selected_documents_products = state.selected_documents_products.filter(el => el.document_id != document_id)
}

export function setselected_base_documents(state, base_document){
  if (!state.selected_rows.find(el => el.id == base_document.id))
    state.selected_rows.push(base_document)
}
export function setselected_documents_products(state, selected_documents_products){
  state.selected_documents_products = selected_documents_products
}
export function deleteselected_base_documents(state, base_document){
  let i = state.selected_rows.findIndex( element => element.id == base_document.id);
  if (i >= 0) {
    state.selected_rows.splice(i, 1);
  }
}

export function setPagination (state, pagination) {
  state.pagination = pagination;
}

export function setPage(state, page) {
  state.params.page = page;
}

export function setDefaultParams (state) {
  Object.assign(state.params, {
    paginate: false,
    page: 1,
    perPage: 30,
    filter: "",
    filterDate: [],
    sortBy: "voucher_date",
    sort: "DESC",
    closed: false,
    retained: false,
    rejected: false,
    seller_id: [],
    user_id: null,
    city_id: null,
    state_auth: ["03", "05"],
    state_backorder: ["1", "2"],
    product: [],
    detailed_by_product: 1,
    contact: null,
    document: ""
  });
}


// WEBPACK FOOTER //
// ./src/modules/base-documents/mutations.js